import BaseApi from './BaseApi'

export default {
  async create(data) {
    return await BaseApi.post('/site-work-monthly-results/new', data)
  },
  
  async search(params) {
    return await BaseApi.get('/site-work-monthly-results/search', { params })
  },
  
  async update(data) {
    return await BaseApi.post('/site-work-monthly-results/update', data)
  },
  
  async delete(data) {
    return await BaseApi.post('/site-work-monthly-results/delete', data)
  }
}
